angular.module('impactx.datepicker').directive('ixDatePicker', ['$timeout', function($timeout) {
    return {
        scope: {
            date: "=",
            minDate: "=",
            maxDate: "=",
            required: "=",
            readOnly: "=",
            name: "@",
            placeHolder: "@",
            requiredLabel: "@",
            dialogData: "=",
            label: "=",
            topLabel: "=",
            noWatcherDeletion: "=",
            onChange: "&",
            hideAsterisk: "=",
            hideLabel: "="
        },
        restrict: 'E',
        templateUrl: 'shared/datepicker/templates/datepicker.tmpl.html',
        transclude: true,
        link: function(scope, element) {
            scope.$watch("date.dateValue", function(newValue) {
                if(newValue) {
                    if(!angular.isDate(newValue)) {
                        scope.date.dateValue = new Date(newValue);

                        // this is better than  scope.$broadcast('md-calendar-change', scope.date.dateValue) because the form stays clean
                        if(scope.dialogData) {
                            scope.dialogData.$setPristine();
                            scope.dialogData.$setUntouched();
                        }
                    }
                }
                else {
                    if(!scope.date) {
                        scope.date = {};
                    }
                    scope.date.dateValue = null;
                }
            });

            // Local midnight of the given day, so bounds are compared by calendar day only.
            function startOfDay(date) {
                return new Date(date.getFullYear(), date.getMonth(), date.getDate());
            }
            function isBeforeRealMinDate(date) {
                if (scope.minDate === null || scope.minDate === undefined) {
                    return false;
                }
                return startOfDay(date).getTime() < startOfDay(new Date(scope.minDate)).getTime();
            }
            function isAfterRealMaxDate(date) {
                if (scope.maxDate === null || scope.maxDate === undefined) {
                    return false;
                }
                return startOfDay(date).getTime() > startOfDay(new Date(scope.maxDate)).getTime();
            }

            function getExceptionDays() {
                var result = [];
                if (scope.date && scope.date.allowedExceptionDays) {
                    for (var i = 0; i < scope.date.allowedExceptionDays.length; i++) {
                        var exceptionDate = new Date(scope.date.allowedExceptionDays[i]);
                        if (!isNaN(exceptionDate)) {
                            result.push(exceptionDate);
                        }
                    }
                }
                return result;
            }

            // Recompute the md-datepicker window. The internal bounds only ever *widen* the real
            // minDate/maxDate so an exception day outside them can still be reached;
            function recomputeInternalBounds() {
                var exceptionDays = getExceptionDays();
                var i;

                if (scope.minDate === null || scope.minDate === undefined) {
                    scope.minDateInternal = scope.minDate;
                }
                else {
                    var minInternal = new Date(scope.minDate);
                    for (i = 0; i < exceptionDays.length; i++) {
                        if (exceptionDays[i].getTime() < minInternal.getTime()) {
                            minInternal = new Date(exceptionDays[i]);
                        }
                    }
                    scope.minDateInternal = minInternal;
                    if (!isNaN(scope.minDateInternal)) {
                        while (!scope.allowedDaysFilter(scope.minDateInternal) && !isAfterRealMaxDate(scope.minDateInternal)) {
                            scope.minDateInternal.setDate(scope.minDateInternal.getDate() + 1);
                        }
                    }
                }

                if (scope.maxDate === null || scope.maxDate === undefined) {
                    scope.maxDateInternal = scope.maxDate;
                }
                else {
                    var maxInternal = new Date(scope.maxDate);
                    for (i = 0; i < exceptionDays.length; i++) {
                        if (exceptionDays[i].getTime() > maxInternal.getTime()) {
                            maxInternal = new Date(exceptionDays[i]);
                        }
                    }
                    scope.maxDateInternal = maxInternal;
                    if (!isNaN(scope.maxDateInternal)) {
                        while (!scope.allowedDaysFilter(scope.maxDateInternal) && !isBeforeRealMinDate(scope.maxDateInternal)) {
                            scope.maxDateInternal.setDate(scope.maxDateInternal.getDate() - 1);
                        }
                    }
                }
            }

            // Validation for dates outside of min/max date range
            var pendingValidationRefresh = null;
            function refreshDatepickerValidation() {
                if (pendingValidationRefresh) {
                    $timeout.cancel(pendingValidationRefresh);
                }
                pendingValidationRefresh = $timeout(function() {
                    pendingValidationRefresh = null;
                    // Two md-datepickers live under ng-if in the template; only one is present.
                    var datepickers = element.find('md-datepicker');
                    for (var i = 0; i < datepickers.length; i++) {
                        var datepickerCtrl = angular.element(datepickers[i]).controller('mdDatepicker');
                        if (datepickerCtrl) {
                            datepickerCtrl.updateErrorState();
                        }
                    }
                }, 0, false);
            }

            // $timeout is not cancelled with the scope, unlike $watch.
            scope.$on("$destroy", function() {
                if (pendingValidationRefresh) {
                    $timeout.cancel(pendingValidationRefresh);
                }
            });

            function recomputeInternalBoundsAndRefresh() {
                recomputeInternalBounds();
                refreshDatepickerValidation();
            }
            scope.$watch("minDate", recomputeInternalBoundsAndRefresh);
            scope.$watch("maxDate", recomputeInternalBoundsAndRefresh);
            scope.$watchCollection("date.allowedExceptionDays", recomputeInternalBoundsAndRefresh);

            scope.allowedDaysFilter = function(date) {
                var day = date.getDay();
                var dayOfMonth = date.getDate();
                var month = date.getMonth();
                var year = date.getFullYear();

                // An exception day is always selectable - it wins over minDate, maxDate, allowedDays and
                // notAllowedHolidayDays. Compared by calendar day in local time, like the closed days below.
                if (scope.date && scope.date.allowedExceptionDays) {
                    for (var e = 0; e < scope.date.allowedExceptionDays.length; e++) {
                        var exceptionDate = new Date(scope.date.allowedExceptionDays[e]);
                        if (dayOfMonth === exceptionDate.getDate() && month === exceptionDate.getMonth() && year === exceptionDate.getFullYear()) {
                            return true;
                        }
                    }
                }

                // enforce the real minDate/maxDate here
                if (isBeforeRealMinDate(date) || isAfterRealMaxDate(date)) {
                    return false;
                }

                var dayAllowed = !scope.date.allowedDays ? true : scope.date.allowedDays.indexOf(day) >= 0;
                if (dayAllowed && scope.date.notAllowedHolidayDays) {
                    for (var i = 0; i < scope.date.notAllowedHolidayDays.length; i++) {
                        var holidayDate = new Date(scope.date.notAllowedHolidayDays[i]);
                        if (dayOfMonth === holidayDate.getDate() && month === holidayDate.getMonth() && year === holidayDate.getFullYear()) {
                            return false;
                        }
                    }
                }

                return dayAllowed;
            };

            recomputeInternalBoundsAndRefresh();
        }
    };
}]);